import * as Msal from 'msal';
import { getEnvDetail } from '../../utils/env';

const envDetail = getEnvDetail();
const MsalConfig = envDetail.msalConfig;

// Initialize the authentication
export default new Msal.UserAgentApplication(MsalConfig);
